import React from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Theme, Typography, useMediaQuery, useTheme } from '@mui/material';

import { SlideShowItem } from '@models/ui/SlideShowItem';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    position: 'relative',
    // background:({image}: any) => `linear-gradient(to top, #3204fdba, #9907facc), url(${image}) no-repeat top center`,
    [theme.breakpoints.down('sm')]: {
      height: 600,
    },
    [theme.breakpoints.down('md')]: {
      height: 480,
    },
    height: 700,
  },
  info: {
    left: ({ isMobile, isTablet }: any) =>
      isMobile ? '4vw' : isTablet ? '8vw' : '10vw',
    top: ({ isMobile, isTablet, isDesktop }: any) => {
      return isMobile ? 110 : isTablet ? 110 : isDesktop ? 200 : 152;
    },
    right: ({ isMobile, isTablet, isDesktop }: any) => {
      return isMobile ? '4vw' : isTablet ? '8vw' : isDesktop ? '42vw' : '56vw';
    },
    position: 'absolute',
    [theme.breakpoints.down('xl')]: {
      width: 450,
    },
    [theme.breakpoints.down('lg')]: {
      width: 350,
    },
  },
  complement: {
    [theme.breakpoints.only('xl')]: {
      fontSize: 58,
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: 52,
    },
    [theme.breakpoints.only('md')]: {
      fontSize: 44,
    },
    [theme.breakpoints.only('sm')]: {
      fontSize: 36,
    },
    fontSize: 32,
    fontWeight: 'bold',
  },
}));

type SlideItemProps = {
  item: SlideShowItem;
};

export const SlideItem: React.FC<SlideItemProps> = ({ item }) => {
  const { breakpoints, palette } = useTheme();
  const isMini = useMediaQuery(breakpoints.down('xs'));
  const isDesktop = useMediaQuery(breakpoints.up('lg'));
  const isTablet = useMediaQuery(breakpoints.down('md'));
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const classes = useStyles({ isMini, isMobile, isTablet, isDesktop, image: item.image });
  return (
    <Box className={classes.root}>
      <Box
        component={'img'}
        src={item.image}
        sx={{
          width: '100%',
          height: 950,
        }}
        alt={item.title}
        className={classes.root}
        style={{ objectFit: 'cover' }}
      />
      {/* <div 
        className={classes.root}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // background: `linear-gradient(to top, #3204fdba, #9907facc), url(${item.image}) no-repeat top center`,
          backgroundImage: `url(${item.image})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: `100% ${isMobile ? "600px" : isTablet ? "480px" : "700px"}`,
          boxShadow: "inset 0 0 99999px rgba(0, 120, 255, 0.5)",
        }}
      /> */}
      <Box className={classes.info}>
        <Typography
          sx={{
            fontSize: {
              xl: 56,
              lg: 40,
              md: 32,
              sm: 24,
              xs: 20,
            },
          }}
          fontWeight={'bold'}
          color={palette.common.white}
        >
          {item.title}
          <span className={classes.complement}>{item.complement}</span>
        </Typography>
        <Typography
          sx={{
            fontSize: {
              xl: 42,
              lg: 40,
              md: 32,
              sm: 22,
              xs: 16,
            },
          }}
          fontWeight={'normal'}
          color={palette.common.white}
        >
          {item.subtitle}
        </Typography>
      </Box>
    </Box>
  );
};
